function mainProduct() {
  document.addEventListener("DOMContentLoaded", () => {
    const roots = document.querySelectorAll("[data-product]");

    roots.forEach((root) => {
      const variants = window.productVariants || [];
      const qtyContainer = root.querySelector("[data-max-quantity]");

      galleryCarousel(root);
      thumbsInit(root);
      quantitySelector(root, qtyContainer);
      variantBadges(root, variants, qtyContainer);
    });
  });
}

////////// GALLERY CAROUSEL //////////
function galleryCarousel(root) {
  const carousel = root.querySelector("[data-carousel]");
  const slides = root.querySelectorAll(
    ".shimokita-honey__product__gallery-slide",
  );

  const prevBtn = root.querySelector("[data-prev]");
  const nextBtn = root.querySelector("[data-next]");
  const currentEl = root.querySelector("[data-current]");
  const galleryUI = root.querySelector("[data-gallery-ui]");
  const dots = root.querySelectorAll("[data-dot-index]");

  if (!carousel || slides.length === 0) return;

  let currentIndex = 0;

  function updateDots(index) {
    dots.forEach((d) => d.classList.remove("is-active"));
    dots[index]?.classList.add("is-active");
  }

  function updateUI(index) {
    currentIndex = index;

    if (currentEl) currentEl.textContent = index + 1;

    const thumbs = root.querySelectorAll(
      ".shimokita-honey__product__thumbnail",
    );
    thumbs.forEach((t) => t.classList.remove("is-active"));
    thumbs[index]?.classList.add("is-active");

    updateDots(index);

    if (prevBtn) prevBtn.disabled = index === 0;
    if (nextBtn) nextBtn.disabled = index === slides.length - 1;
  }

  function scrollToIndex(index) {
    if (index < 0 || index >= slides.length) return;

    const slide = slides[index];

    carousel.scrollTo({
      left: slide.offsetLeft - carousel.offsetLeft,
    });

    updateUI(index);
  }

  // arrows
  prevBtn?.addEventListener("click", () => scrollToIndex(currentIndex - 1));
  nextBtn?.addEventListener("click", () => scrollToIndex(currentIndex + 1));

  // dots
  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      scrollToIndex(Number(dot.dataset.dotIndex));
    });
  });

  // scroll tracking
  let ticking = false;
  carousel.addEventListener("scroll", () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      const scrollLeft = carousel.scrollLeft;

      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, i) => {
        const distance = Math.abs(
          slide.offsetLeft - carousel.offsetLeft - scrollLeft,
        );
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      if (closestIndex !== currentIndex) {
        updateUI(closestIndex);
      }

      ticking = false;
    });
  });

  // hover UI
  if (galleryUI) {
    galleryUI.addEventListener("mouseenter", () => {
      galleryUI.classList.add("is-visible");
    });

    galleryUI.addEventListener("mouseleave", () => {
      galleryUI.classList.remove("is-visible");
    });
  }

  root.scrollToIndex = scrollToIndex;

  updateUI(0);
}

////////// THUMBNAILS //////////
function thumbsInit(root) {
  const thumbs = root.querySelectorAll(".shimokita-honey__product__thumbnail");

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      root.scrollToIndex(Number(thumb.dataset.index));
    });
  });

  thumbs[0]?.classList.add("is-active");
}

////////// QUANTITY SELECTOR //////////
function quantitySelector(root, qtyContainer) {
  const qtyDisplay = qtyContainer.querySelector("[data-qty-display]");
  const minusBtn = qtyContainer.querySelector("[data-qty-minus]");
  const plusBtn = qtyContainer.querySelector("[data-qty-plus]");
  const qtyInput = root.querySelector("[data-qty-input]");

  let qty = 1;

  let inventoryMax = parseInt(qtyContainer.dataset.maxQuantity) || 1;
  let checkoutMax = parseInt(qtyContainer.dataset.checkoutMaxQuantity) || 0;

  function getMaxQty() {
    // if checkout limit exists, cap by it
    if (checkoutMax > 0) {
      return Math.min(inventoryMax, checkoutMax);
    }
    // otherwise just inventory
    return inventoryMax;
  }

  function updateQtyDisplay() {
    const maxQty = getMaxQty();

    // clamp qty if needed
    if (qty > maxQty) qty = maxQty;

    qtyDisplay.textContent = qty;
    if (qtyInput) qtyInput.value = qty;

    minusBtn.classList.toggle("is-disabled", qty <= 1);
    plusBtn.classList.toggle("is-disabled", qty >= maxQty);
  }

  minusBtn.addEventListener("click", () => {
    if (qty > 1) {
      qty--;
      updateQtyDisplay();
    }
  });

  plusBtn.addEventListener("click", () => {
    const maxQty = getMaxQty();
    if (qty < maxQty) {
      qty++;
      updateQtyDisplay();
    }
  });

  root.updateQtyDisplay = (newInventoryMax) => {
    inventoryMax = newInventoryMax;
    updateQtyDisplay();
  };

  updateQtyDisplay();
}

////////// AVAILABILITY PILL //////////
function updateAvailabilityPill(root, isAvailable) {
  const pill = root.querySelector("[data-availability-badge]");
  if (!pill) return;

  pill.classList.toggle("is-soldout", !isAvailable);
  pill.textContent = isAvailable
    ? window.themeStrings.inStock
    : window.themeStrings.outOfStock;
}

////////// VARIANT BADGES //////////
function variantBadges(root, variants, qtyContainer) {
  const badges = root.querySelectorAll(".shimokita-honey__product__variation");
  const priceEl = root.querySelector("[data-price]");
  const discountBadge = root.querySelector("[data-discount-badge]");
  const addBtn = root.querySelector("[data-add-to-cart]");
  const variantInput = root.querySelector("input[data-variant-id]");

  if (badges.length === 0) return;

  const firstBadge = badges[0];
  const firstInventory = parseInt(firstBadge.dataset.variantInventory) || 1;
  const firstAvailable = firstBadge.dataset.variantAvailable === "true";

  if (variantInput) variantInput.value = firstBadge.dataset.variantId;
  qtyContainer.dataset.maxQuantity = firstInventory;
  root.updateQtyDisplay(firstInventory);

  updateAvailabilityPill(root, firstAvailable);

  if (addBtn) {
    addBtn.disabled = !firstAvailable;
    addBtn.classList.toggle("disabled", !firstAvailable);
  }

  const firstVariant = variants.find(
    (v) => String(v.id) === firstBadge.dataset.variantId,
  );

  if (firstVariant) {
    updatePriceAndDiscount(firstVariant, priceEl, discountBadge);
    switchVariantImage(root, String(firstVariant.id));
  }

  badges.forEach((badge) => {
    badge.addEventListener("click", () => {
      badges.forEach((b) => b.classList.remove("is-active"));
      badge.classList.add("is-active");

      const variantId = badge.dataset.variantId;

      if (variantInput) variantInput.value = variantId;

      const variantInventory = parseInt(badge.dataset.variantInventory) || 1;
      const available = badge.dataset.variantAvailable === "true";

      qtyContainer.dataset.maxQuantity = variantInventory;
      root.updateQtyDisplay(variantInventory);

      updateAvailabilityPill(root, available);

      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.classList.toggle("disabled", !available);
      }

      const variant = variants.find((v) => String(v.id) === variantId);

      if (variant) {
        updatePriceAndDiscount(variant, priceEl, discountBadge);
        switchVariantImage(root, variantId);
        scrollToVariantImage(root, variant);
      }
    });
  });
}

////////// PRICE & DISCOUNT //////////
function updatePriceAndDiscount(variant, priceEl, discountBadge) {
  if (!priceEl) return;

  const price = (variant.price / 100).toLocaleString();
  const taxLabel = window.shopTaxesIncluded
    ? window.themeStrings.taxesIncluded
    : window.themeStrings.taxesExcluded;

  const priceValueSpan = priceEl.querySelector("[data-price-value]");
  const taxSpan = priceEl.querySelector(".tax-label");

  if (priceValueSpan) priceValueSpan.textContent = price;
  if (taxSpan) taxSpan.textContent = `(${taxLabel})`;

  if (!discountBadge) return;

  const compareAt = variant.compare_at_price;

  if (compareAt && compareAt > variant.price) {
    const discount = Math.ceil(((compareAt - variant.price) * 100) / compareAt);
    discountBadge.innerHTML = `<span data-discount-value>${discount}</span>% OFF`;
    discountBadge.classList.remove("is-hidden");
  } else {
    discountBadge.innerHTML = "";
    discountBadge.classList.add("is-hidden");
  }
}

////////// SWITCH VARIANT IMAGE //////////
function switchVariantImage(root, variantId) {
  const images = root.querySelectorAll("[data-variant-image]");
  const productImage = root.querySelector("[data-product-image]");

  let foundMatch = false;

  images.forEach((img) => {
    if (img.dataset.variantId === variantId) {
      img.classList.remove("is-hidden");
      foundMatch = true;
    } else {
      img.classList.add("is-hidden");
    }
  });

  if (productImage) {
    productImage.classList.toggle("is-hidden", foundMatch);
  }
}

////////// SCROLL TO VARIANT IMAGE //////////
function scrollToVariantImage(root, variant) {
  if (!variant.featured_image) return;

  const slides = root.querySelectorAll(
    ".shimokita-honey__product__gallery-slide",
  );

  const variantImageSrc = variant.featured_image.src.split("?")[0];

  slides.forEach((slide, index) => {
    const visibleImg = slide.querySelector("img:not(.is-hidden)");
    if (!visibleImg) return;

    const src = (visibleImg.currentSrc || visibleImg.src || "").split("?")[0];

    if (src.includes(variantImageSrc)) {
      root.scrollToIndex(index);
    }
  });
}

mainProduct();
